import { hasCapability, type User } from "../base";

export const holdup = {
  read: (user: User) => hasCapability(user, "holdup.read"),
};
